export var ScaleTypes;

(function (ScaleTypes) {
  ScaleTypes["LINEAR"] = "linear";
  ScaleTypes["POWER"] = "power";
  ScaleTypes["LOG"] = "log";
  ScaleTypes["IDENTITY"] = "identity";
  ScaleTypes["TIME"] = "time";
  ScaleTypes["QUANTILE"] = "quantile";
  ScaleTypes["QUANTIZE"] = "quantize";
  ScaleTypes["THRESHOLD"] = "threshold";
  ScaleTypes["CAT"] = "cat";
})(ScaleTypes || (ScaleTypes = {}));

export var StyleScaleType;

(function (StyleScaleType) {
  StyleScaleType["CONSTANT"] = "constant";
  StyleScaleType["VARIABLE"] = "variable";
})(StyleScaleType || (StyleScaleType = {}));

export var AttributeType;

(function (AttributeType) {
  AttributeType[AttributeType["Attribute"] = 0] = "Attribute";
  AttributeType[AttributeType["InstancedAttribute"] = 1] = "InstancedAttribute";
  AttributeType[AttributeType["Uniform"] = 2] = "Uniform";
})(AttributeType || (AttributeType = {}));
//# sourceMappingURL=IStyleAttributeService.js.map